// extracted by mini-css-extract-plugin
export default {"root":"Operate_root__w-t+h"};